import { render, staticRenderFns } from "./ModalVideoConferencing.vue?vue&type=template&id=1268d30b&scoped=true"
import script from "./ModalVideoConferencing.vue?vue&type=script&lang=js"
export * from "./ModalVideoConferencing.vue?vue&type=script&lang=js"
import style0 from "./ModalVideoConferencing.vue?vue&type=style&index=0&id=1268d30b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1268d30b",
  null
  
)

export default component.exports